import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import TourItinerarySection from '../../sections/CommonSection/TourItinerarySection'
import { shimlaManaliData } from './tourPackageData'

const ShimlaManali = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Shimla - Kullu - Manali" />
            <CommonBreadcrumb items={["Shimla - Kullu - Manali"]} />
            <TourItinerarySection {...shimlaManaliData} />
            <Footer />
        </>
    )
}

export default ShimlaManali